














































import { Component, Vue, Watch } from 'vue-property-decorator';
import store from '@/store';
import MainLayout from '@/layouts/Main.vue';
import { Lang } from '@/lang/en/info.ts';
import LocationsService from '@/services/locations';

@Component({
  components: {
    MainLayout,
  },
})
export default class Info extends Vue {
  private lang: object = Lang;
  private isLoaded: boolean = false;

  private beforeCreate() {
    LocationsService.Get();
  }

  private addLocation() {
    this.$router.push({ name: 'locations.store' });
  }

  private editLocation(locationId: number) {
    this.$router.push({ name: 'locations.edit',  params: { id: locationId.toString() } });
  }

  get locations() {
    return store.getters['Locations/getCurrentLocations'];
  }

  @Watch('locations')
  private onChange(newVal) {
    this.isLoaded = true;
  }

}
